module.exports = __webpack_public_path__ + "media/images/partner_logo_1-882d1058c774ff53497b514a951793e8.png";